import { Base } from '@studiometa/js-toolkit';
import ProductStickyAddToCart from './ProductStickyAddToCart.js';
import Gallery from './Gallery/index.js';
import GalleryCursor from './Gallery/GalleryCursor.js';
import ZoomedGallery from './ZoomedGallery/index.js';
import Buybox from './Buybox.js';
import PanelSize from './PanelSize.js';

/**
 * Product Component
 *
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
      Gallery,
      GalleryCursor,
      ZoomedGallery,
      Buybox,
      ProductStickyAddToCart,
      PanelSize,
    },
  };
}
